import { ExecutionLoads } from "../../../models/ExecutionLoads.model";
import { SearchById } from "../../../models/home/SearchLoadByReferenceId.model";
import { MyLoad } from "../../../models/myLoad/myLoad";
import { IUserDetails } from "../../../schemas/user";
import { IONICWrapper, isMobile } from "../../../utils/common";
import { USER_ROLES } from "../../../utils/constants";
import { getFormatRoles } from "../../../utils/formatData";
import { FetchFromMyLoadConfig } from "../../../utils/MyLoads.util";

export const searchByLoadId = (userDetails:any,referenceId:any,searchByReferenceId:any,fetchShipments:any,isShipmentsAvailable:any,setReferenceId:any=null) => {
const DISPATCHER = IONICWrapper.details.auth.user.roles && IONICWrapper.details.auth.user.roles.length && IONICWrapper.details.auth.user.roles.includes(USER_ROLES.carrierDispatcher)|| false;
    const referenceIdTrim = referenceId.trim();
    if(referenceIdTrim.length === 0) {
      return;
    }
    const searchLoadByIdModal = getSearchLoadByIdModal(userDetails, referenceIdTrim);
    
    if(isMobile &&((DISPATCHER && fetchShipments) && isShipmentsAvailable === 0)){
      const executionModel: MyLoad = new MyLoad();
      const myLoadsMaxPageSize = FetchFromMyLoadConfig("PageSize");
      executionModel.filter = {
        carrierAssigned: true, driverAssigned: true, carrierTendered: true, inTransit: true, deliveredNeedsPaperWork: true,deliveredWithPaperWork: true };
      executionModel.pagination = {
          pageSize: myLoadsMaxPageSize,
          pageIndex: 0,
        }
      fetchShipments(executionModel.getMyLoadCount(), false, ()=>{
        searchByReferenceId(
          searchLoadByIdModal.getRequestPayload(),
          false,
          ()=>{ setReferenceId(""); }
        );
      });
    }
    else{
      searchByReferenceId(
        searchLoadByIdModal.getRequestPayload(),
        false,
        ()=>{ setReferenceId(""); }
      );
    }
  };

function getSearchLoadByIdModal(userDetails: IUserDetails, referenceId: any) {
  const searchLoadByIdModal = new SearchById();
  const userRole = getFormatRoles();
  searchLoadByIdModal.userId = userDetails?.memberDetailsResponse?.member?.upn;
  searchLoadByIdModal.carrierId = userDetails?.memberDetailsResponse?.member?.carrierId;
  searchLoadByIdModal.page = 0;
  searchLoadByIdModal.carrierScac = (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.carrierScac) || "";
  searchLoadByIdModal.carrierTier = (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.carrierTier) || "";
  searchLoadByIdModal.managedEquipmentCapability = (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.managedEquipmentCapability) || null;
  searchLoadByIdModal.nonManagedEquipmentCapability = (userDetails && userDetails.memberDetailsResponse &&
    userDetails.memberDetailsResponse.carrierInfo && userDetails.memberDetailsResponse.carrierInfo.nonManagedEquipmentCapability) || null;
  searchLoadByIdModal.userRole = userRole.join(",");
  searchLoadByIdModal.loadNumberAlias = referenceId;
  return searchLoadByIdModal;
}
  